const Audio = {
  state: {
    is_press: false,
  },
  getters: {
    is_mic_mute: (state, rootState) => {
      if (rootState.cur_channel_data.channel_id) {
        return Boolean(
          rootState.cur_channel_data.mute || // 用户被静音
            rootState.cur_channel_data.mute_room // 用户被房间静音
        );
      } else {
        return false;
      }
    },
    is_no_mic: (state, rootState) => {
      return (
        rootState.setting_data.micDevices.length === 0 &&
        !rootState.is_phone_mic_connecting
      );
    },
    is_earphone_mute: (state, rootState) => {
      if (rootState.cur_channel_data.channel_id) {
        return Boolean(rootState.cur_channel_data.mute_earphone);
      } else {
        return false;
      }
    },
    is_press: (state) => {
      return state.is_press;
    },
  },
  mutations: {
    SET_IS_PRESS(state, v) {
      state.is_press = v;
    },
  },
};

export default Audio;
